<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card :title="'DEFAULT SUNDRY COST FOR PRICING'" class="">
        <template slot="actions">
          <vs-button v-can="'view-sundry-costs-setting'" @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus"
            class="mr-4" color="primary" type="filled" v-if="sundry_cost_list.length < 4">create</vs-button>
        </template>
        <div id="margin-list-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="sundry_cost_list">
              <template slot="thead">
                <vs-th width="30%">FG TYPE</vs-th>
                <vs-th width="20%">COST (GBP/KG)</vs-th>
                <vs-th width="30%">NOTES</vs-th>
                <vs-th width="20%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].formulation_type">
                    {{ data[indextr].formulation_type }}
                  </vs-td>

                  <vs-td :data="data[indextr].cost">
                    {{ Number(data[indextr].cost).toFixed(2) }}
                  </vs-td>

                  <vs-td :data="data[indextr].note">
                    <vx-read-more :length="100" :text="data[indextr].note" />
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row" v-can="'edit-sundry-costs-setting'">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)" class="ml-3" size="small"
                          color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Remove" position="left">
                        <vs-button @click.stop="openConfirm(data[indextr].id)" class="ml-3" size="small" color="danger"
                          type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of"
              description-title="Records" description :description-items="descriptionItems"
              :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </div>
      </vx-card>
    </div>
    <add-new-sundry-cost-pop-up ref="addNewSundryCostPopUp"/>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import AddNewSundryCostPopUp from '@/components/popups/settings/sundry-cost/AddNewSundryCostPopUp.vue';

import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import { defaultPagination, perPageList } from "@/constants/config";
const SundryCostRepository = RepositoryFactory.get('sundry_cost');

export default {
  name: "SundryCostListSettings",
  data() {
    return {
      sundry_cost_list: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
    }
  },
  components: {
    AddNewSundryCostPopUp
  },
  methods: {
    async refreshData() {
      await this.fetchSundryCostList()
    },
    async fetchSundryCostList() {
      await this.$vs.loading({
        container: '#margin-list-table',
        scale: 0.45
      })
      const { data } = await SundryCostRepository.getSundryCostList(this.page, this.filterQuery, this.perPage, this.sort)
      this.sundry_cost_list = data.data
      this.meta = data.meta
      this.$vs.loading.close('#margin-list-table > .con-vs-loading')
    },
    async onClickAdd() {
      await this.$refs.addNewSundryCostPopUp.openPopup()
    },
    async onClickUpdate(id) {
      await this.$refs.addNewSundryCostPopUp.openPopup(id)
    },
    openConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete this ?',
        accept: this.onClickDelete,
        parameters: [id]
      })
    },
    async onClickDelete(params) {
      try {
        await SundryCostRepository.deleteSundryCost(params[0])
        await this.fetchSundryCostList()
        await this.showSuccessMessage('Sundry cost deleted!');
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    filterQueryUpdate() {
      this.fetchSundryCostList()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchSundryCostList()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchSundryCostList()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
  },
  async mounted() {
    await this.fetchSundryCostList()
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  watch: {
    page() {
      this.fetchSundryCostList()
    },
    perPage() {
      this.fetchSundryCostList()
    }
  }
}
</script>

<style scoped></style>
